import React, { Component } from "react";
import axios from 'axios'
import { Input,Button,Form,Modal,message } from "antd";
import { strings } from 'res';
import TextArea from "antd/lib/input/TextArea";


export class Basic extends Component {
  constructor(props){
    super(props)
    this.state = {
      homePageInd:{},
      visible: false,
      updateMessage:"",
      upload:{
        name: 'file',
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        headers: {
          authorization: 'authorization-text',
        },
        maxSize:1000000,
        onChange(info) {
          if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
          }
          if (info.file.status === 'done') {
            message.success(`${info.file.name} file uploaded successfully`);
          } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
          }
        }
      }
    }
    this.handleChange = this.handleChange.bind(this);
    this.onFinish = this.onFinish.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleOk = this.handleOk.bind(this);
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleOk = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  componentDidMount(){
    axios.get(`${strings.url.content_url}/homePage/read`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin":"*"
      }
    }).then(doc=>{
      if(this.props.bahasa === "Indonesia"){
        this.setState({
          homePageInd:doc.data.HomeInd[0]
        })
      }else{
        this.setState({
          homePageInd:doc.data.HomeEng[0]
        })
      }
     
    })
  }

  handleChange(event){
    this.setState({
      homePageInd:{
        ...this.state.homePageInd,
        [event.target.name]: event.target.value
       }
    })
  }

   onFinish = (values) =>{
    if(this.props.bahasa === "Indonesia"){
      axios.post(`${strings.url.content_url}/homePage/updateIndonesia`,this.state.homePageInd, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin":"*"
        }
      }).then(doc=>{
        this.setState({
          visible: true,
          updateMessage:doc.data.msg
        });
      })
    }else{
      axios.post(`${strings.url.content_url}/homePage/updateEnglish`,this.state.homePageInd, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin":"*"
        }
      }).then(doc=>{
        this.setState({
          visible: true,
          updateMessage:doc.data.msg
        });
      })
    }
  }

  render() {
    return (
      <div>
          <Modal
          title="Message!"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <h3 style={{textAlign:"center"}}>{this.state.updateMessage}</h3>
        </Modal>
        <h1>{this.props.bahasa}</h1>
        <Form onFinish={this.onFinish} > 
        <label>Heading - 1</label><br/><label style={{color:"red"}}>(Recommended Max 10 Words)</label>
        <Input onChange={this.handleChange} name="heading_1" value={this.state.homePageInd.heading_1}  placeholder="Heading-1" />
        <br />
        <br />
        <label>Heading - 2</label><br/><label style={{color:"red"}}>(Recommended Max 10 Words)</label>
        <Input onChange={this.handleChange} name="heading_2" value={this.state.homePageInd.heading_2} placeholder="Heading-2" />    
        <br />
        <br />
        <label>Heading - 3</label><br/><label style={{color:"red"}}>(Recommended Max 10 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.heading_3} name="heading_3" placeholder="Heading-3" />
        <br />
        <br />
        <label>Heading - 1 Desciption</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.output_1} name="output_1"  placeholder="Output-1" />
        <br />
        <br />
        <label>Heading - 2 Description</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.output_3} name="output_3" placeholder="Output-3" />
        <br />
        <br />       
        <label>Heading - 3 Description</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.output_2} name="output_2" placeholder="Output-2" />
        <br />
        <br />
        <label>Value Chains</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.value_chain} name="value_chain" placeholder="Value-Chains" />
        <br />
        <br />
        <label>Value Chain 1 Title</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.value_chain_1} name="value_chain_1" placeholder="Value-Chains-1" />
        <br />
        <br />
        <label>Value Chain 2 Title</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.value_chain_2} name="value_chain_2" placeholder="Value-Chains-2" />
        <br />
        <br />
        <label>Value Chain 3 Title</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.value_chain_3} name="value_chain_3" placeholder="Value-Chains-3" />
        <br />
        <br />
        <label>Value Chain 4 Title</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.value_chain_4} name="value_chain_4" placeholder="Value-Chains-4" />
        <br />
        <br />
        <label>Value Chain 5 Title</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.value_chain_5} name="value_chain_5" placeholder="Value-Chains-5" />
        <br />
        <br />
        {/* <label>Stories</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.stories} name="stories" placeholder="Stories" />
        <br />
        <br />
        <label>Stories Description</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.stories_description} name="stories_description" placeholder="Stories Description" />
        <br />
        <br />
        <label>Impact</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.impact} name="impact" placeholder="Impact" />
        <br />
        <br />
        <label>Impact Description</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.impact_description} name="impact_description" placeholder="Impact Description" />
        <br />
        <br />
        <label>News</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.news} name="news" placeholder="News" />
        <br />
        <br />
        <label>News Description</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.news_description} name="news_description" placeholder="News Description" />
        <br />
        <br />
        <label>Media</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.media} name="media" placeholder="Media" />
        <br />
        <br />
        <label>Media Description</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.media_description} name="media_description" placeholder="Media Description" />
        <br />
        <br /> */}
        <label>Resources</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.resources} name="resources" placeholder="Resources" />
        <br />
        <br />
        <label>Resources Description</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.resources_description} name="resources_description" placeholder="Resources Description" />
        <br />
        <br />
        <label>Publications</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.resources_publications} name="resources_publications" placeholder="Publications" />
        <br />
        <br />
        <label>Publications Description</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.resources_publications_description} name="resources_publications_description" placeholder="Publications Description" />
        <br />
        <br />
        <label>Manuals</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.resources_manuals} name="resources_manuals" placeholder="Manuals" />
        <br />
        <br />
        <label>Manuals Description</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.resources_manuals_description} name="resources_manuals_description" placeholder="Manuals Description" />
        <br />
        <br />
        {/* <label>Newsletters</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.resources_newsletters} name="resources_newsletters" placeholder="Newsletters" />
        <br />
        <br />
        <label>Newsletters Description</label><br/><label style={{color:"red"}}>(Recommended Max 100 Words)</label>
        <TextArea rows={10} onChange={this.handleChange} value={this.state.homePageInd.resources_newsletters_description} name="resources_newsletters_description" placeholder="Newsletters Description" />
        <br />
        <br />
        <label>Contacts</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.contact} name="contact" placeholder="Contact" />
        <br />
        <br />
        <label>View All Stories Text</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.view_all_stories} name="view_all_stories" placeholder="View All Stories" />
        <br />
        <br /> */}
        <label>Button Text</label><br/><label style={{color:"red"}}>(Recommended Max 5 Words)</label>
        <Input onChange={this.handleChange} value={this.state.homePageInd.button} name="button" placeholder="Button" />
        <br />
        <br />
        <Form.Item >
          <Button htmlType="submit" type="primary" style={{width:"100%"}} >Submit</Button>
        </Form.Item>
        </Form>
      </div>
    );
  }
}

export default Basic;
